import { render, staticRenderFns } from "./CompanyWalletUserPointSearchResultBeautify.vue?vue&type=template&id=2dc910f0&scoped=true"
import script from "./CompanyWalletUserPointSearchResultBeautify.vue?vue&type=script&lang=js"
export * from "./CompanyWalletUserPointSearchResultBeautify.vue?vue&type=script&lang=js"
import style0 from "./CompanyWalletUserPointSearchResultBeautify.vue?vue&type=style&index=0&id=2dc910f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc910f0",
  null
  
)

export default component.exports